import { render, staticRenderFns } from "./data-field.vue?vue&type=template&id=2b74766a&"
import script from "./data-field.vue?vue&type=script&lang=js&"
export * from "./data-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports